import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// rebate programe dispatch function
// export const dispatchRebatePrograme = (data) => ({
//   type: ActionTypes.GET_REBATE_PROGRAM,
//   payload: data,
// });

//  error msg dispatch function
export const dispatchErrorMsgOutStandingBalByLabererAndQtr = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_OUTSTANDING_BAL_LABERER_QTR,
  payload: data,
});

// To pass data from req screen to display screen
export const setSearchResult = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_RESULT_OUTSTANDING_DISPUTES_QUARTER,
    payload: data,
  };
};

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});
//Refresh Functinality
export const refreshOustandingByLabelerAndQtr = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR,
  payload: {},
});
export const refreshOustandingByLabelerAndQtrDisplay = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR_DISPLAY,
  payload: {},
});
// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe Dropdown
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(setSearchResult({ errorMessages: [] }));
  // }, 5000);
  dispatch(
    setSearchResult({
      errorMessages: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

//dispatch API
export const dispatchOutstandingByLabererAndQtr = (data) => ({
  type: ActionTypes.SET_OUTSTANDING_BAL_BY_LABERER_AND_QUARTER,
  searchResult: data,
});

//get api data
export const getOutstandingByLabererAndQtr = (values) => (dispatch) => {
  dispatch(setLoading(true));
  // dispatch(dispatchOutstandingByLabererAndQtr([]));
  return axios
    .post(serviceEndPoint.GET_OUTSTANDING_BAL_BY_LABERER_AND_QUARTER, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response?.data?.outstandingBalancebyLabelerandQuarterVO.length === 0
      ) {
        dispatch(showNoDataMessage());
        // dispatch(setOpenModal(true));
      } else {
        dispatch(
          dispatchOutstandingByLabererAndQtr(
            response?.data?.outstandingBalancebyLabelerandQuarterVO
          )
        );
      }
      return response?.data?.outstandingBalancebyLabelerandQuarterVO;
    })
    .catch((response) => {
      dispatch(setLoading(false));
      // dispatch(dispatchOutstandingByLabererAndQtr([]));
    });
};
